import Handlebars from 'handlebars';

import casesTemplate from '../template/casesTemplate.hbs';
import casesData from '../data/cases.json';

import caseImage1 from '../assets/images/cases/case-1.webp';
import caseImage2 from '../assets/images/cases/case-2.webp';
import caseImage3 from '../assets/images/cases/case-3.webp';
import caseImage4 from '../assets/images/cases/case-4.webp';

const swiperWrapper = document.querySelector('.cases__swiper-wrapper');
const screenWidth = window.innerWidth;

const prepareCasesData = data => {
  const enhancedData = data.reverse().map((caseItem, index) => ({
    ...caseItem,
    imgUrl: [caseImage1, caseImage2, caseImage3, caseImage4][index],
  }));

  const step = screenWidth >= 1280 ? 2 : 1;
  const groupedData = [];

  for (let i = 0; i < enhancedData.length; i += step) {
    groupedData.push(enhancedData.slice(i, i + step));
  }

  return groupedData;
};

const renderCasesSlides = () => {
  const groupedData = prepareCasesData(casesData);
  const template = Handlebars.compile(casesTemplate);
  const html = template({ slides: groupedData });
  swiperWrapper.innerHTML = html;
};

renderCasesSlides();
